import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-verificacion-documento',
  templateUrl: './verificacion-documento.component.html',
  styleUrls: ['./verificacion-documento.component.scss'],
  standalone: false
})
export class VerificacionDocumentoComponent implements OnInit, OnDestroy {
  cargando = true;
  valido = false;
  nombreDocumento = 'Carta de porte';
  mensajeError = 'El enlace del QR no es válido o el documento ya no está disponible.';
  private http: HttpClient;

  constructor(httpBackend: HttpBackend, private route: ActivatedRoute) {
    this.http = new HttpClient(httpBackend);
  }

  ngOnInit(): void {
    document.documentElement.classList.add('validacion-certificado-publica');
    document.body.classList.add('validacion-certificado-publica');
    document.getElementById('app-bootstrap-loading')?.remove();
    const uid = this.route.snapshot.queryParamMap.get('uid');
    if (!uid || !/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(uid)) {
      this.mensajeError = 'El enlace del QR no es válido.';
      this.cargando = false;
      return;
    }
    const url = environment.HOST + environment.RECOGIDAS_API + 'deca/documentos/' + encodeURIComponent(uid);
    this.http.get(url, { observe: 'response', responseType: 'blob' }).subscribe({
      next: response => {
        const nombreCodificado = response.headers.get('X-Document-Name');
        if (nombreCodificado) {
          try {
            this.nombreDocumento = decodeURIComponent(nombreCodificado);
          } catch {
            this.nombreDocumento = nombreCodificado;
          }
        }
        const blob = response.body;
        if (!blob) {
          this.valido = false;
          this.mensajeError = 'El servidor no ha devuelto el documento.';
          this.cargando = false;
          return;
        }
        this.mostrarDocumento(blob);
        this.valido = true;
        this.cargando = false;
      },
      error: error => {
        this.valido = false;
        this.mensajeError = error.status === 413
          ? 'El documento supera el límite permitido de 5 MB.'
          : 'El enlace del QR no es válido o el documento ya no está disponible.';
        this.cargando = false;
      }
    });
  }

  private mostrarDocumento(blob: Blob): void {
    const documento = blob.type === 'application/pdf'
      ? blob
      : new Blob([blob], { type: 'application/pdf' });
    const url = URL.createObjectURL(documento);
    window.location.replace(url);
  }

  ngOnDestroy(): void {
    document.documentElement.classList.remove('validacion-certificado-publica');
    document.body.classList.remove('validacion-certificado-publica');
  }
}
